module.exports = __webpack_public_path__ + "static/media/logo_squicker.4a6a6666.svg";